import { ArrowRight, CheckCircle2, Network, Workflow } from 'lucide-react';
import { systemStory } from '../content';

export function ConnectedSystemStory() {
  return (
    <section className="system-story" aria-labelledby="system-story-title">
      <div className="system-story__shell section-shell">
        <header className="system-story__header reveal">
          <span className="section-kicker">From friction to flow</span>
          <h2 id="system-story-title">Your operation, connected end to end.</h2>
          <p>Start with the work as it exists. Then connect the inputs, rules, people, and tools into one dependable operating layer.</p>
        </header>

        <div className="system-map reveal">
          <div className="system-map__column system-map__column--input">
            <span>Before</span>
            <ul>{systemStory.inputs.map((item) => <li key={item.title}><strong>{item.title}</strong><small>{item.detail}</small></li>)}</ul>
          </div>

          <div className="system-map__core">
            <div className="system-map__signal" aria-hidden="true"><ArrowRight /></div>
            <Network aria-hidden="true" />
            <span>Workcrafted operating layer</span>
            <h3>{systemStory.engine.title}</h3>
            <p>{systemStory.engine.description}</p>
            <small><Workflow aria-hidden="true" />{systemStory.engine.proof}</small>
            <div className="system-map__signal system-map__signal--out" aria-hidden="true"><ArrowRight /></div>
          </div>

          <div className="system-map__column system-map__column--output">
            <span>After</span>
            <ul>{systemStory.outcomes.map((item) => <li key={item.title}><CheckCircle2 aria-hidden="true" /><span><strong>{item.title}</strong><small>{item.detail}</small></span></li>)}</ul>
          </div>
        </div>

        <p className="system-story__result reveal">Less chasing. Clearer ownership. Work that keeps moving.</p>
      </div>
    </section>
  );
}
